import axiosInstance from "../axiosInstance";

export const dashboardApi = {
    post: (path, params, headers, cancelToken) =>
        axiosInstance
            .post(`/dashboard${path}`, params, {
                cancelToken: cancelToken?.token,
                headers,
            })
            .then((res) => {
                console.log(res)
                if (res?.data?.error) throw res.data;
                return res?.data;
                // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, headers, cancelToken) =>
        axiosInstance
            .get(
                `/dashboard${path}`,
                { params },
                {
                    cancelToken: cancelToken?.token,
                    headers,
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
};

export const getDashboard = async (params) =>
    dashboardApi.get("/GetDashboard", params);

// export const getInstitutes = async (params) =>
//     dashboardApi.post(
//         "/GetInstitutesByTypeSelection",
//         JSON.stringify(params),
//         { "Content-Type": "application/json" }
//     );
